module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.04b605a.ttf";